// removed by extract-text-webpack-plugin
module.exports = {"address":"Address__address___3Xuwz","map":"Address__map___2yVGC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Address/Address.scss
// module id = 1169
// module chunks = 1